import RankingService from '@/services/ranking.service'
import AuthService from '@/services/auth.service'
import _ from 'lodash'

const state = {
    data: [],
    filterLoading: false,
    requestError: false
}

const getters = {}

const actions = {
    readRanking: async ({ commit }, { amplitude }) => {
        try {
            commit('reading')
            let data = await RankingService.readRanking(amplitude)
            commit('readRankingSuccess', data)
            return null
        } catch (e) {
            commit('readRankingFail')
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    createSolicitation: async ({ commit }, args) => {
        try {
            await RankingService.createSolicitation(args)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    }
}

const mutations = {
    reading(state) {
        state.filterLoading = true
    },

    readRankingSuccess(state, data) {
        const dataFormatted = data.map((item, index) => ({
            ranking_position: index + 1,
            ...item
        }))

        state.data = dataFormatted
        state.filterLoading = false
    },

    async readRankingFail(state) {
        await AuthService.logout()
        state.requestError = true
    }
}

const ranking = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default ranking
export { ranking }
